const setupBidCallerPreBiddingSignalRHub = (hubUrl, isEmployee, listingIds, updateAuctionBiddingData) => {
    let transportMethods = ['webSockets', 'longPolling'];

    let connection = $.connection;
    connection.hub.logging = isEmployee;
    connection.hub.url = hubUrl;

    let hubProxy = connection.bidcallerprebidding;

    if (hubProxy == null || hubProxy == undefined) {
        console.log("SignalR connection failed: No hub was provided");
        return false;
    }

    hubProxy.client.OnPreBidPlaced = (listingId) => {
        updateAuctionBiddingData(listingId, false);
    };

    connection.hub.start({ jsonp: true, transport: transportMethods }).done(function () {
        hubProxy.server.addToGroups(listingIds);
        if (connection.hub.logging == true) { console.log("Connection succeeded"); }
    }).fail(function (e) {
        console.log("SignalR connection failed: " + e);
    });

    connection.hub.disconnected(function () {
        if (connection.hub.logging === true) { console.log("Failed to reconnect"); }
        setTimeout(function () {
            connection.hub.start({ jsonp: true, transport: transportMethods }).done(function () {
                hubProxy.server.addToGroups(listingIds);
                if (connection.hub.logging == true) { console.log("Connection succeeded"); }
            }).fail(function (e) {
                console.log("SignalR connection failed: " + e);
            });
        }, 3000); // attempt to restart connection after 3 seconds.
    });

    connection.hub.reconnecting(function () {
        if (connection.hub.logging === true) { console.log("Attemptting to reconnect"); }
    });

    connection.hub.reconnected(function () {
        if (connection.hub.logging === true) { console.log("Attempt to reconnect has succeeded"); }
    });

    return connection;
};

export {
    setupBidCallerPreBiddingSignalRHub
};